/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import {
	call, takeLatest, fork, all, put,
} from 'redux-saga/effects';
import api from '../../../services/api';
import { INITIAL_STATE_VALUES, Types } from '../../ducks/alertas/geo';
import executeAction from '../comum/executeAction';

/** SAGAS */
function* asyncGeoBuscarPorAlertaId(action) {
	yield executeAction(function* () {
		const { alertaId, callback } = action;

		const { data } = yield call(api.get, `/alerta/buscar/${alertaId}`);

		let { geo } = data;

		geo = geo || INITIAL_STATE_VALUES.geo;

		geo.alertaId = data.id;
		geo.alertaStatus = data.statusAtualAlerta;

		yield put({
			type: Types.GEO_BUSCAR_POR_ALERTA_ID_REDUCER,
			geo,
			data,
		});

		if (callback) callback();
	}, Types.GEO_BUSCAR_POR_ALERTA_ID);
}

// TAKES
function* takeGeoBuscarPorAlertaId() {
	yield takeLatest(Types.GEO_BUSCAR_POR_ALERTA_ID, asyncGeoBuscarPorAlertaId);
}

export default function* root() {
	yield all([
		fork(takeGeoBuscarPorAlertaId),
	]);
}
